"use client";

import React from "react";
import CustomSelect from "@/app/_components/Shared/CustomSelect";
import TextInput from "@/app/_components/Shared/TextInput";
import styles from "./index.module.scss";
import {countries} from "@/app/countries";

const visaOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
];

const jurisdictions = [
    { value: "Mainland", label: "Mainland" },
    { value: "Free Zone", label: "Free Zone" },
    { value: "Offshore", label: "Offshore" },
    { value: "Not Sure", label: "Not Sure" },
];

const businessActivities = [
    { value: "it", label: "IT" },
    { value: "consulting", label: "Consulting" },
    { value: "e_commerce", label: "E-commerce" },
    { value: "trading", label: "Trading" },
    { value: "general_services", label: "General Services" },
    { value: "crypto", label: "Crypto" },
    { value: "real_estate", label: "Real Estate" },
    { value: "financial_services", label: "Financial Services" }
];

const turnoverRanges = [
    { value: "less_than_500k", label: "Less than AED 500,000" },
    { value: "500k_to_1m", label: "AED 500,000 – AED 1,000,000" },
    { value: "1m_to_10m", label: "AED 1,000,000 – AED 10,000,000" },
    { value: "above_10m", label: "Above AED 10,000,000" }
];

const depositRanges = [
    { value: "25k_to_50k", label: "AED 25,000 – 50,000" },
    { value: "50k_to_100k", label: "AED 50,000 – 100,000" },
    { value: "above_100k", label: "AED 100,000+" }
];

const countryOptions = countries.map((country) => ({
    value: country.name,
    label: country.name,
}));

const BusinessDetails = ({ data, onChange }) => {
    return (
        <div className={styles.container}>
            <div>
                <h2>Company & Ownership Details</h2>
            </div>

            {/* Visa Selection */}
            <p>Do the owners have a UAE visa or residency?</p>
            <div className={styles.radioGroup}>
                {visaOptions.map((option) => (
                    <label
                        key={option.value}
                        className={`${styles.radioOption} ${
                            data.uae_visa === option.value ? styles.checked : ""
                        }`}
                    >
                        <input
                            type="radio"
                            name="visaStatus"
                            value={option.value}
                            checked={data.uae_visa === option.value}
                            onChange={() => onChange("uae_visa", option.value)}
                        />
                        {option.label}
                    </label>
                ))}
            </div>

            {/* Owner Nationality */}
            <CustomSelect
                options={countryOptions}
                value={data.nationalities}
                isMulti
                onChange={(selected) => onChange("nationalities", selected)}
                placeholder="Owner(s) nationalities"
            />

            {/* Company Registration Location */}
            <div className={styles.selectGroup}>
                <TextInput
                    placeholder="Location"
                    value={data.location || ""}
                    onChange={(e) => onChange("location", e.target.value)}
                />
                <CustomSelect
                    options={jurisdictions}
                    value={jurisdictions.find((j) => j.value === data.jurisdiction)}
                    onChange={(selected) => onChange("jurisdiction", selected.value)}
                    placeholder="Select"
                />
            </div>

            {/* Business Activity */}
            <CustomSelect
                options={businessActivities}
                value={data.business_activity}
                onChange={(selected) => onChange("business_activity", selected)}
                placeholder="Describe business activity"
            />

            {/* Annual Turnover */}
            <CustomSelect
                options={turnoverRanges}
                value={data.annual_turnover}
                onChange={(selected) => onChange("annual_turnover", selected)}
                placeholder="What is the expected annual turnover?"
            />

            {/* Deposit Amount */}
            <CustomSelect
                options={depositRanges}
                value={data.deposit_amount}
                onChange={(selected) => onChange("deposit_amount", selected)}
                placeholder="Deposit amount available for the account"
            />

            {/* Operating Countries */}
            <CustomSelect
                options={countryOptions}
                value={data.countries}
                isMulti
                onChange={(selected) => onChange("countries", selected)}
                placeholder="Which countries does the company operate in?"
            />
        </div>
    );
};

export default BusinessDetails;
